import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { FormType } from "../components/enums";
import { setFormType } from "../components/formSettings.slice";

export const useSetFormType = (formType: FormType): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFormType(formType));
  }, [dispatch, formType]);
};
